import { render, staticRenderFns } from "./GraficaMaterialRegionEvolucion.vue?vue&type=template&id=36c43814&"
import script from "./GraficaMaterialRegionEvolucion.vue?vue&type=script&lang=js&"
export * from "./GraficaMaterialRegionEvolucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports